export enum SopType {
	SHEAR = 'shear',
	TRANSFORM = 'transform',
	UV_LAYOUT = 'uvLayout',
	UV_TRANSFORM = 'uvTransform',
	UV_UNWRAP = 'uvUnwrap',
}
